import React from 'react';
import { CheckCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { socialStats, testimonials } from '../data/testimonials';
export function SocialProofSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-176" data-mp="35qq9z8a12c6h">
      <Reveal className="mx-auto max-w-6xl" data-id="element-177" data-mp="35s9p2vjy6h6o">
        <div className="mb-10 text-center" data-id="element-178" data-mp="30qu7jdgzast1">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-ocean" data-id="element-179" data-mp="30t6xodww49h6">VOCI DALLE AULE</p>
          <h2 className="text-3xl font-extrabold text-brand-deep md:text-4xl" data-id="element-180" data-mp="2d3m471341ttn">Cosa dicono i docenti</h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3" data-id="element-181" data-mp="2mzpewvc130s7">
          {testimonials.map(({
          name,
          role,
          initials,
          messages
        }) => <article key={name} className="flex flex-col overflow-hidden rounded-2xl border border-brand-sand bg-brand-main shadow-sm" data-id="element-182" data-mp="2i0cro9h8vrp3">
              <header className="flex items-center gap-3 border-b border-brand-sand bg-brand-ocean px-4 py-3 text-white" data-id="element-183" data-mp="3tg1ff32bouqy">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/20 font-display text-xs font-bold" data-id="element-184" data-mp="yg20dga0y8tc">
                  {initials}
                </span>
                <div className="min-w-0" data-id="element-185" data-mp="18cwwxtmqlz4z">
                  <p className="truncate text-sm font-bold" data-id="element-186" data-mp="18e81vwrx5cxo">{name}</p>
                  <p className="truncate text-[11px] text-white/75" data-id="element-187" data-mp="1ce0gor7wofbh">{role}</p>
                </div>
              </header>
              <div className="flex flex-1 flex-col gap-2 p-4" data-id="element-188" data-mp="fqc9v5dao978">
                {messages.map(({
              from,
              text,
              time
            }) => <div key={text} className={`max-w-[88%] rounded-2xl px-3.5 py-2.5 text-sm leading-snug shadow-sm ${from === 'docente' ? 'self-start rounded-bl-md bg-brand-alt text-brand-text' : 'self-end rounded-br-md bg-brand-ocean/10 text-brand-deep'}`} data-id="element-189" data-mp="klhtfxj85bs5">
                    <p data-id="element-190" data-mp="14aslnqq19v8q">{text}</p>
                    <p className="mt-1 flex items-center justify-end gap-1 text-[10px] font-semibold text-brand-gray" data-id="element-191" data-mp="14a0o4acvlnft">
                      {time}
                      <CheckCheckIcon className="h-3 w-3 text-brand-ocean" aria-hidden="true" data-id="element-192" data-mp="z9lcpoc5mq0h" />
                    </p>
                  </div>)}
              </div>
            </article>)}
        </div>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-3 gap-4 rounded-2xl border border-brand-sand bg-brand-main px-4 py-6 text-center" data-id="element-193" data-mp="lbodsla8a7in">
          {socialStats.map(([value, label]) => <div key={label} data-id="element-194" data-mp="ucctrlj6mhy6">
              <strong className="block font-display text-2xl font-extrabold text-brand-ocean" data-id="element-195" data-mp="udnutdl8tbll">{value}</strong>
              <span className="mt-1 block text-[11px] font-bold uppercase tracking-wider text-brand-gray" data-id="element-196" data-mp="qa82uuk4bzf8">
                {label}
              </span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}